import { BackButton } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export function PageBackButton({ href }: { href: string }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BackButton
      label={t("common.goBack")}
      onClick={() => navigate(href)}
    />
  );
}
